import { createSlice } from '@reduxjs/toolkit';
import { CarInventory } from 'types';

export interface MessageParams {
    title: string;
    message: string;
    variant: 'info' | 'success' | 'error' | 'warning'|''
}

export interface ModalParams {
    title: string;
    message: string;
    variant: 'info' | 'success' | 'error' | 'warning'|''
}

export interface ConfirmModalParams {
    title: string;
    message: string|React.ReactNode;
    variant: 'primary' | 'danger' | 'warning';
    confirmLabel?: string;
    cancelLabel?: string;
}

export interface StockTransferModalParams {
    allowChanges?: {
        fromLocation?: boolean;
        toLocation?: boolean;
        cars?: boolean;
    };
    initialCars?: CarInventory[];
    initialFromLocation?: {
        id: string | number;
        name: string;
    };
    initialToLocation?: {
        id: string | number;
        name: string;
    };
    initialFulfillTime?: number; // date.now() or getTime();
    initialReceiveTime?: number;
    /**
     * When true (default), Car Fulfill Time and Car Receive Time are required and validated.
     * When false, both are optional; omit from the DTO when left empty (e.g. Pending transfer).
     * Ignored when `showTime` is false (times are not shown; requirement is always off).
     */
    requireFulfillReceiveTimes?: boolean;
    /** When false, fulfill/receive time fields are hidden; `requireFulfillReceiveTimes` is treated as false. Default true. */
    showTime?: boolean;
    /** When false, the cars field is hidden; cars on submit come from `initialCars` only. Default true. */
    showCars?: boolean;
    title?: string;
    submitButtonText?: string;
    showCancelBtn?: boolean;
    allowSkipTransfer?: boolean;
    skipTransferButtonText?: string;
}

export const appUISlice = createSlice({
    name: 'appUI',
    initialState: {
        toast: { show: false, title: '', message: '', variant: '' },
        modal: { show: false, title: '', message: '', variant: '' },
        confirmModal: { show: false },
        stockTransferModal: { show: false, params: null as StockTransferModalParams | null },
        cancelModal: { show: false },
        isMobileApp: false,
        loading: false
    },
    reducers: {
        setIsMobileApp: (state, action) => { state.isMobileApp = action.payload },
        showModal: (state, action) => {
            state.modal = {
                show: true,
                variant: action.payload.variant,
                title: action.payload.title,
                message: action.payload.message
            }
        },
        // Soft close: keep title/message/variant for Framer exit animation (TWModal).
        clearModal: (state) => {
            state.modal.show = false;
        },
        showConfirmModal: (state) => {
            state.confirmModal = { show: true };
        },
        clearConfirmModal: (state) => {
            state.confirmModal = { show: false };
        },
        showStockTransferModal : (state, action) => {
            state.stockTransferModal = {
                show: true,
                params: action.payload || null
            }
        },
        clearStockTransferModal : (state) => {
            state.stockTransferModal = {
                show: false,
                params: null
            }
        },
        showCancelModal: (state) => {
            state.cancelModal = { show: true };
        },
        clearCancelModal: (state) => {
            state.cancelModal = { show: false };
        },
        showMessage: (state, action) => {
            state.toast = {
                show: true,
                variant: action.payload.variant,
                title: action.payload.title,
                message: action.payload.message
            }
        },
        clearMessage: (state) => {
            state.toast = {
                show: false,
                title: '',
                message: '',
                variant: ''
            }
            
        },
        setLoading: (state, action) => { state.loading = action.payload },
    }
});
export const { 
    showMessage, clearMessage, setIsMobileApp,
    showModal, clearModal,
    showConfirmModal, clearConfirmModal,
    showStockTransferModal, clearStockTransferModal,
    showCancelModal, clearCancelModal,
    setLoading
} = appUISlice.actions;
export default appUISlice.reducer;